<!--
 * @Description:
 * @Author: 诺
 * @Date: 2021-12-19 14:19:13
 * @LastEditors: 诺
 * @LastEditTime: 2022-12-06 19:36:05
-->
<template>
  <div id="boxMian" v-if="configInfo" class="boxMian">
    <div class="page-wrapper">
      <div class="logo"><img :src="configInfo.topLogoImg" /></div>
      <div class="kv"><img src="https://assets.rurushishi.com/activies/yy-help-2022-12/couponTitle.png" /></div>
      <div class="operationBtn">
        <div class="btn" @click.stop="handle('couponRule')">优惠券规则</div>
        <!-- <div class="btn" @click.stop="handle('prize')">我的礼品</div> -->
        <!-- <div class="btn" @click.stop="handle('ranking')">排行榜</div> -->
      </div>
      <div class="card">
        <div class="cardBg"></div>
        <div class="cardMain">

          <div class="city">
            <!-- {{ city }}
            <div class="icon"></div> -->
            <Multiselect v-model="city" :options="cityList" :searchable="false" :allow-empty="false"
              :show-labels="false" track-by="city" label="city">
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.city }}
              </template>
            </Multiselect>
          </div>
          <div class="coupon">
            <div class="item" v-for="(item, index) in newCouponList" :key="index">
              <div class="projectTitle"><span>项目名称：</span>{{ item.projectName }}</div>
              <div class="intro" @click="handleCoupon(item)">
                <div class="info">
                  <!-- 抵扣<span>10000</span> -->
                  {{ item.name }}
                  <!-- <div class="company">元</div> -->
                </div>
                <div class="conupnRight">
                  <div :class="['reduce']">
                    ￥<span> {{ parseFloat(item.amount / 100) }}</span>
                    <div class="company">元</div>
                  </div>
                  <img class="pay" src="https://assets.rurushishi.com/activies/yy-help-2022-12/pay.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ActBaseBtnHome />
    </div>
  </div>
</template>

<script>
import Vue from "vue/dist/vue.js";
import Multiselect from "vue-multiselect";

const statusTipMap = {
  0: "该活动无效",
  1: "该活动待发布",
  2: "该活动未上线",
  4: "该活动已暂停",
  5: "该活动已结束",
  6: "活动未开始",
};
export default {
  components: {
    Multiselect
  },
  props: {},
  data() {
    return {
      configInfo: null,
      userInfo: {},
      city: {},
      couponList: [],
      newCouponList: [],
      saleInfo: {},
      cityList: [{ "city": "北京", "type": 0 }, { "city": "廊坊", "type": 1 }, { "city": "石家庄", "type": 3 }, { "city": "太原", "type": 4 }, { "city": "大连", "type": 5 }, { "city": "济南", "type": 6 }, { "city": "青岛", "type": 7 }, { "city": "沈阳", "type": 8 }, { "city": "天津", "type": 9 }, { "city": "苏州", "type": 10 }, { "city": "温州", "type": 11 }, { "city": "无锡", "type": 12 }, { "city": "镇江", "type": 13 }, { "city": "合肥", "type": 14 }, { "city": "南昌", "type": 15 }, { "city": "武汉", "type": 16 }, { "city": "郑州", "type": 17 }, { "city": "成都", "type": 18 }, { "city": "贵阳", "type": 19 }, 
      // { "city": "昆明", "type": 20 },
       { "city": "西安", "type": 21 }, { "city": "佛山", "type": 22 }, { "city": "福州", "type": 23 }, { "city": "广州", "type": 24 }, { "city": "江门", "type": 25 }, { "city": "茂名", "type": 26 }, { "city": "厦门", "type": 27 }, { "city": "湛江", "type": 28 }, { "city": "中山", "type": 29 }]
    };
  },

  filters: {
  },
  watch: {
    city: {
      handler(val) {
        this.upDataCoupon();
        // console.log(val)
      },
      deep: true,
    }
  },
  computed: {
  },
  mounted() {
    console.log(this.$actCode);
    this.$wx.ready(() => {
      this.initAct();
    });
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
    this.saleInfo = JSON.parse(localStorage.getItem("saleInfo"))
    console.log(this.userInfo)
    this.city = { city: this.userInfo.city }
  },
  methods: {
    // 页面配置
    async initAct() {
      // let url = this.$apizt.action.getConfig;
      // const { data, result } = await this.$httpzt.requestRestFul(url, {});
      // if (result) {
      //   this.configInfo = {
      //     // ...data,
      //     // receiveAddress:data.receiveAddress,
      //     // status:data.status,
      //     ...data,
      //     uiExt: "",
      //     ...JSON.parse(data.uiExt),
      //   };

      //   document.title = data.actName;
      //   const cookieConfig = { ...this.configInfo, actRule: "" };
      //   console.log(cookieConfig);
      //   this.$util.cookie.set("configInfo", JSON.stringify(cookieConfig), {
      //     expires: 30,
      //   });
      this.configInfo = this.$configInfo;
      this.getCouponPrize()
    },
    // 获取优惠券
    async getCouponPrize() {
      let url = this.$apizt.action.getCouponPrize;
      const { data, result } = await this.$httpzt.requestRestFul(url, {});
      if (result) {
        this.couponList = data;
        this.upDataCoupon()
      }
    },
    handle(type) {
      const id=this.cityList.filter(item=>item.city==this.city.city)[0].type
      this.$router.push({
        path: `/${type}/${id}`,
        query: this.$route.query,
      });
    },
    upDataCoupon() {

      // console.log(this.city)
      const city = this.city.city
      // console.log(this.couponList)
      // const  city= '太原'
      let currentCity = []
      // this.couponList.filter(item => item.uiExt && JSON.parse(item.uiExt).cityList.indexOf(city) > -1 && item.groupId != city)
      let saleProject =[]
      if(this.saleInfo){
        saleProject = this.couponList.filter(item => item.uiExt && JSON.parse(item.uiExt).projectId == this.saleInfo.projectId)
      }
      saleProject.map(item => {
        const obj = { ...item, ...JSON.parse(item.uiExt) };
        currentCity.push(obj)
      })
      this.couponList.map(item => {
        const obj = { ...item, ...JSON.parse(item.uiExt) };
        if(this.saleInfo){
          if (obj.city == city && obj.projectId != this.saleInfo.projectId) {
            currentCity.push(obj)
          }
        }else{
          if (obj.city == city ) {
            currentCity.push(obj)
          }
        }
      })


      let relationCity = []
      //  this.couponList.filter(item => item.uiExt && JSON.parse(item.uiExt).cityList.indexOf(city) > -1 && item.groupId != city)

      this.newCouponList = currentCity.concat(relationCity)
    },
    async handleCoupon(item) {
      // 优惠券
      console.log(item);
      let receiveKey = item.code;
      if (item.isReceive) {
        return this.$showToast("已经购买或锁定过当前优惠券了!", "提示");
      }
      if (item.winType == 5) {
        let url = this.$apizt.action.lockCoupon.api;
        const { data, result } = await this.$httpzt.requestRestFul(`${url}${item.code}`, {}, "post");
        if (result) {
          receiveKey = data;
        } else {
          return;
        }
      }
      this.$modal.form.alert({
        type: item.winType == 5 ? "key" : "code",
        prizeType: 2,
        code: item.code,
        prizeName: item.name,
        receiveKey: receiveKey,
        winType: item.winType,
        address: item.address
      });
    },
  },
};
</script>



<style src="vue-multiselect/dist/vue-multiselect.min.css"/>
<style lang="scss">
.city {
  .multiselect {
    width: 310px;
    height: 27px;
    min-height: 27px;
    border-radius: 5px;
  }

  .multiselect__select {
    width: 27px;
    height: 27px;
  }

  .multiselect__tags {
    height: 27px;
    min-height: 27px;
    line-height: 27px;
    padding-top: 0;
    border: none;
  }

  .multiselect__single {
    height: 27px;
    min-height: 27px;
    line-height: 27px;
    background-color: transparent;
    margin-bottom: 0;
  }

  .multiselect__content-wrapper {
    border-width: 1px;
  }
}
</style>
<style lang="scss" scoped>
div {
  position: relative;
  box-sizing: border-box;

  img {
    width: 100%;
  }
}

.boxMian {
  width: 100%;
  background-position: top center;
  background-repeat: repeat;
  background-size: 100% auto;
  background: linear-gradient(90deg, #930710, #c90e24);

  .page-wrapper {
    position: relative;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    padding-bottom: 120px;
    background-image: url('https://assets.rurushishi.com/activies/yy-help-2022-12/luckyBg.png');

    .logo {
      width: 332px;
      margin: 21px auto 0;
    }

    .kv {
      width: 297px;
      text-align: center;
      margin: 37px auto 0;
    }

    .operationBtn {
      position: absolute;
      top: 140px;
      right: 0;
      z-index: 9;

      .btn {
        padding: 0 5px 0 9px;
        background: linear-gradient(0deg, #721B1A, #C43835);
        box-shadow: 0px 2px 4px 0px rgba(25, 1, 1, 0.6);
        border-radius: 11px 0 0 11px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        line-height: 23px;
        font-family: PingFang;
        font-weight: 800;
        color: #FFFFFF;
        margin-bottom: 9px;
        letter-spacing: 1px;
      }
    }


    .card {
      width: 375px;
      background-image: url('http://assets.rurushishi.com/activies/yy-help-2022-12/modalBg.png');
      background-position: top center;
      background-repeat: no-repeat;
      background-size: 100% auto;
      padding-top: 22px;
      margin-top: 15px;
      padding-bottom: 17px;

      .cardBg {
        position: absolute;
        width: 341px;
        height: calc(100% - 68px);
        left: 18px;
        top: 68px;
        background: linear-gradient(180deg, #ffeee1, #F8DFC4);
        border-radius: 0 0 10px 10px;
      }

      .cardMain {
        display: flex;
        flex-direction: column;
        align-items: center;


        .city {
          width: 310px;
          height: 27px;
          background: #FFFFFF;
          box-shadow: 0px 1px 3px 0px rgba(149, 148, 148, 0.38);
          border-radius: 5px;
          padding: 0 9px;
          margin: 12px auto 0;
          font-size: 13px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #333333;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .icon {
            border-top: 10px solid #999999;
            border-bottom: 0px solid transparent;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
          }
        }

        .coupon {
          .item {
            margin-top: 22px;

            .projectTitle {
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #B21A21;

              span {
                color: #646464;
              }
            }

            .intro {
              margin-top: 11px;
              width: 319px;
              height: 104px;
              background-image: url('http://assets.rurushishi.com/activies/yy-help-2022-12/coupon.png?v=1');
              background-position: top center;
              background-repeat: no-repeat;
              background-size: 100% auto;
              display: flex;
              align-items: center;

              .info {
                width: 220px;
                font-size: 18px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #E9EBD1;
                display: flex;
                align-items: flex-end;
                justify-content: center;

                span {
                  font-size: 50px;
                  margin-bottom: -5px;
                }

                div {
                  width: 16px;
                  height: 16px;
                  background: #EDE9D6;
                  border: 1px solid #C3151D;
                  border-radius: 50%;
                  font-size: 11px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  color: #C10000;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }
              }

              .conupnRight {
                width: 98px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .reduce {
                  font-size: 14px;
                  font-weight: 400;
                  color: #E9EBD1;
                  display: flex;
                  align-items: flex-end;
                  justify-content: center;

                  span {
                    font-size: 35px;
                    font-family: PingFang SC;
                    font-weight: 600;
                    margin-bottom: -5px;
                  }

                  div {
                    width: 10px;
                    height: 10px;
                    background: #EDE9D6;
                    border: 1px solid #C3151D;
                    border-radius: 50%;
                    font-size: 7px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #C10000;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  }
                }

                .pay {
                  margin-top: 4px;
                  width: 56px;
                }
              }
            }
          }
        }
      }


    }

  }

}
</style>
